import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.canLoadMore}}
  {{hide-application-footer}}
{{/if}}

<div class="container show-badge {{this.model.slug}}">
  <h1>
    <LinkTo @route="badges.index">{{i18n "badges.title"}}</LinkTo>
    /
    {{this.model.name}}
  </h1>

  <div class="show-badge-details">
    <BadgeCard
      @badge={{this.model}}
      @size="large"
      @count={{this.userBadges.grant_count}}
    />
    <div class="badge-grant-info {{if this.hiddenSetTitle '' 'hidden'}}">
      <div>
        {{#if this.canSelectTitle}}
          <div class="grant-info-item">
            {{i18n "badges.allow_title"}}
            <DButton
              @action={{this.toggleSetUserTitle}}
              @icon="pencil-alt"
              class="btn-default pad-left"
            />
          </div>
        {{/if}}
        {{#if this.model.multiple_grant}}
          <div class="grant-info-item">
            {{i18n "badges.multiple_grant"}}
          </div>
        {{/if}}
      </div>
    </div>

    {{#if this.canSelectTitle}}
      <div class="badge-set-title {{if this.hiddenSetTitle 'hidden' ''}}">
        <BadgeTitle
          @selectableUserBadges={{this.selectableUserBadges}}
          @closeAction={{this.toggleSetUserTitle}}
        />
      </div>
    {{/if}}
  </div>

  {{#if this.userBadges}}
    <div class="user-badges {{this.model.slug}}">
      <LoadMore @selector=".badge-info" @action={{action "loadMore"}}>
        <div class="badges-granted">
          {{#each this.userBadges as |ub|}}
            <UserInfo
              @user={{ub.user}}
              @size="medium"
              @date={{ub.granted_at}}
              class="badge-info"
            >
              <div class="granted-on">
                {{html-safe
                  (i18n "badges.granted_on" date=(format-date ub.granted_at))
                }}
              </div>

              {{#if ub.post_number}}
                <a
                  class="post-link"
                  href="{{ub.topic.url}}/{{ub.post_number}}"
                >{{html-safe ub.topic.fancyTitle}}</a>
              {{/if}}
            </UserInfo>
          {{/each}}
        </div>
      </LoadMore>

      {{#unless this.canLoadMore}}
        {{#if this.canShowOthers}}
          <div>
            <a
              id="show-others-with-badge-link"
              href={{this.model.url}}
              class="btn btn-default"
            >{{i18n "badges.others_count" count=this.othersCount}}</a>
          </div>
        {{/if}}
      {{/unless}}
    </div>

    <ConditionalLoadingSpinner @condition={{this.canLoadMore}} />
  {{/if}}
</div>
*/
{
  "id": "xPvYXvs3",
  "block": "[[[41,[30,0,[\"canLoadMore\"]],[[[1,\"  \"],[1,[34,1]],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[15,0,[29,[\"container show-badge \",[30,0,[\"model\",\"slug\"]]]]],[12],[1,\"\\n  \"],[10,\"h1\"],[12],[1,\"\\n    \"],[8,[39,2],null,[[\"@route\"],[\"badges.index\"]],[[\"default\"],[[[[1,[28,[35,3],[\"badges.title\"],null]]],[]]]]],[1,\"\\n    /\\n    \"],[1,[30,0,[\"model\",\"name\"]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"show-badge-details\"],[12],[1,\"\\n    \"],[8,[39,4],null,[[\"@badge\",\"@size\",\"@count\"],[[30,0,[\"model\"]],\"large\",[30,0,[\"userBadges\",\"grant_count\"]]]],null],[1,\"\\n    \"],[10,0],[15,0,[29,[\"badge-grant-info \",[52,[30,0,[\"hiddenSetTitle\"]],\"\",\"hidden\"]]]],[12],[1,\"\\n      \"],[10,0],[12],[1,\"\\n\"],[41,[30,0,[\"canSelectTitle\"]],[[[1,\"          \"],[10,0],[14,0,\"grant-info-item\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"badges.allow_title\"],null]],[1,\"\\n            \"],[8,[39,5],[[24,0,\"btn-default pad-left\"]],[[\"@action\",\"@icon\"],[[30,0,[\"toggleSetUserTitle\"]],\"pencil-alt\"]],null],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[41,[30,0,[\"model\",\"multiple_grant\"]],[[[1,\"          \"],[10,0],[14,0,\"grant-info-item\"],[12],[1,\"\\n            \"],[1,[28,[35,3],[\"badges.multiple_grant\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canSelectTitle\"]],[[[1,\"      \"],[10,0],[15,0,[29,[\"badge-set-title \",[52,[30,0,[\"hiddenSetTitle\"]],\"hidden\",\"\"]]]],[12],[1,\"\\n        \"],[8,[39,6],null,[[\"@selectableUserBadges\",\"@closeAction\"],[[30,0,[\"selectableUserBadges\"]],[30,0,[\"toggleSetUserTitle\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"userBadges\"]],[[[1,\"    \"],[10,0],[15,0,[29,[\"user-badges \",[30,0,[\"model\",\"slug\"]]]]],[12],[1,\"\\n      \"],[8,[39,7],null,[[\"@selector\",\"@action\"],[\".badge-info\",[28,[37,8],[[30,0],\"loadMore\"],null]]],[[\"default\"],[[[[1,\"\\n        \"],[10,0],[14,0,\"badges-granted\"],[12],[1,\"\\n\"],[42,[28,[37,10],[[28,[37,10],[[30,0,[\"userBadges\"]]],null]],null],null,[[[1,\"            \"],[8,[39,11],[[24,0,\"badge-info\"]],[[\"@user\",\"@size\",\"@date\"],[[30,1,[\"user\"]],\"medium\",[30,1,[\"granted_at\"]]]],[[\"default\"],[[[[1,\"\\n              \"],[10,0],[14,0,\"granted-on\"],[12],[1,\"\\n                \"],[1,[28,[35,12],[[28,[37,3],[\"badges.granted_on\"],[[\"date\"],[[28,[37,13],[[30,1,[\"granted_at\"]]],null]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\\n\"],[41,[30,1,[\"post_number\"]],[[[1,\"                \"],[10,3],[14,0,\"post-link\"],[15,6,[29,[[30,1,[\"topic\",\"url\"]],\"/\",[30,1,[\"post_number\"]]]]],[12],[1,[28,[35,12],[[30,1,[\"topic\",\"fancyTitle\"]]],null]],[13],[1,\"\\n\"]],[]],null],[1,\"            \"]],[]]]]],[1,\"\\n\"]],[1]],null],[1,\"        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n\"],[41,[51,[30,0,[\"canLoadMore\"]]],[[[41,[30,0,[\"canShowOthers\"]],[[[1,\"          \"],[10,0],[12],[1,\"\\n            \"],[10,3],[14,1,\"show-others-with-badge-link\"],[15,6,[30,0,[\"model\",\"url\"]]],[14,0,\"btn btn-default\"],[12],[1,[28,[35,3],[\"badges.others_count\"],[[\"count\"],[[30,0,[\"othersCount\"]]]]]],[13],[1,\"\\n          \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[8,[39,15],null,[[\"@condition\"],[[30,0,[\"canLoadMore\"]]]],null],[1,\"\\n\"]],[]],null],[13]],[\"ub\"],false,[\"if\",\"hide-application-footer\",\"link-to\",\"i18n\",\"badge-card\",\"d-button\",\"badge-title\",\"load-more\",\"action\",\"each\",\"-track-array\",\"user-info\",\"html-safe\",\"format-date\",\"unless\",\"conditional-loading-spinner\"]]",
  "moduleName": "discourse/templates/badges/show.hbs",
  "isStrictMode": false
});